import { Typography, useMediaQuery, useTheme } from '@mui/material';
export interface IStepTitle {
  title: string;
  subTitle?: string;
}
const StepTitle: React.FC<IStepTitle> = ({
  title,
  subTitle
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  return <>
			<Typography variant="header2" data-test-id="schedule-layout-main-title" mb={2} data-sentry-element="Typography" data-sentry-source-file="StepTitle.tsx">
				{title}
			</Typography>
			{subTitle && <Typography variant={isSmallScreen ? 'bodyMediumBook' : 'bodyLargeBook'} data-test-id="schedule-layout-subtitle">
					{subTitle}
				</Typography>}
		</>;
};
export default StepTitle;